export enum ContentType {
  Json = 'application/json',
  Text = 'text/plain',
  Html = 'text/html',
  Form = 'application/x-www-form-urlencoded',
}
